// extracted by mini-css-extract-plugin
module.exports = {"container":"component-module--container--9t1sj","decorator":"component-module--decorator--1idM5","text":"component-module--text--2sGqg"};